module.exports = new __parcel__URL__("AudioPanelErrorIllustration.24fce6d6.svg").toString();